import { Button, InputNumber, message } from 'antd'
import { nrgCard95DataAnalyticsImport } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { getApiTargetInfo } from 'core'
import { Content, Label, Title } from 'core/screen-util'
import moment from 'moment'
import React, { useContext, useState } from 'react'
import { connect } from 'react-redux'

const Card95DataAnalytics = ({ targetInfo }) => {
  const [year, setYear] = useState(parseInt(moment().get('YYYY')))
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)

  const importCard95 = _ => {
    setSpinning(true)
    nrgCard95DataAnalyticsImport(targetInfo)(year).fork(setError, _ => {
      setSpinning(false)
      message.info('Data Imported.')
    })
  }

  return (
    <Content>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '300px 150px 150px 200px',
          gap: 20,
        }}
      >
        <Title>Card95 Data Import</Title>
        <Label>Year :</Label>
        <InputNumber
          onChange={setYear}
          value={year}
          style={{ width: '100%' }}
        />
        <Button type="danger" onClick={importCard95}>
          Import Data
        </Button>
      </div>
    </Content>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Card95DataAnalytics)
